import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { listarProcessos } from '../services/api'
import Layout from './Layout'

const SBG = { aberto:'#E6F1FB', tramitando:'#FAEEDA', pendente:'#FAEEDA', concluido:'#EAF3DE', arquivado:'#F1EFE8' }
const SC  = { aberto:'#185FA5', tramitando:'#854F0B', pendente:'#854F0B', concluido:'#3B6D11', arquivado:'#5F5E5A' }
const SL  = { aberto:'Aberto', tramitando:'Tramitando', pendente:'Pendente', concluido:'Concluído', arquivado:'Arquivado' }

export function StatusBadge({ status }) {
  return (
    <span style={{ background:SBG[status]||'#f3f4f6', color:SC[status]||'#374151', padding:'2px 10px', borderRadius:99, fontSize:11, whiteSpace:'nowrap' }}>
      {SL[status]||status}
    </span>
  )
}

export default function Processos() {
  const navigate = useNavigate()
  const [processos, setProcessos] = useState([])
  const [busca, setBusca] = useState('')
  const [status, setStatus] = useState('')
  const [load, setLoad] = useState(true)

  useEffect(() => {
    const t = setTimeout(carregar, 300)
    return () => clearTimeout(t)
  }, [busca, status])

  async function carregar() {
    setLoad(true)
    try {
      const res = await listarProcessos({ busca, status, limite: 50 })
      setProcessos(res.data.processos || [])
    } catch(e) {}
    setLoad(false)
  }

  return (
    <Layout>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h1 style={{ fontSize:18, fontWeight:500, margin:0 }}>Processos</h1>
        <button onClick={() => navigate('/processos/novo')}
          style={{ background:'#185FA5', color:'white', border:'none', borderRadius:8, padding:'8px 16px', fontSize:13, cursor:'pointer' }}>
          + Novo processo
        </button>
      </div>

      <div style={{ display:'flex', gap:10, marginBottom:16 }}>
        <input value={busca} onChange={e=>setBusca(e.target.value)}
          placeholder="Buscar por número, nome ou assunto..."
          style={{ flex:1, padding:'8px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }} />
        <select value={status} onChange={e=>setStatus(e.target.value)}
          style={{ padding:'8px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
          <option value="">Todos</option>
          <option value="aberto">Aberto</option>
          <option value="tramitando">Tramitando</option>
          <option value="pendente">Pendente</option>
          <option value="concluido">Concluído</option>
          <option value="arquivado">Arquivado</option>
        </select>
      </div>

      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        {load
          ? <div style={{ padding:32, textAlign:'center', color:'#9ca3af' }}>Carregando...</div>
          : processos.length === 0
            ? <div style={{ padding:32, textAlign:'center', color:'#9ca3af', fontSize:14 }}>Nenhum processo encontrado.</div>
            : processos.map((p,i) => (
              <div key={p.id} onClick={() => navigate(`/processos/${p.id}`)} style={{
                display:'flex', alignItems:'center', gap:12, padding:'12px 16px',
                borderBottom:i<processos.length-1?'1px solid #f3f4f6':'none',
                cursor:'pointer', transition:'background 0.1s'
              }}
              onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
              onMouseLeave={e=>e.currentTarget.style.background='white'}>
                <div style={{ fontFamily:'monospace', fontSize:12, color:'#185FA5', minWidth:110 }}>{p.numero}</div>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:13, fontWeight:500 }}>{p.assunto}</div>
                  <div style={{ fontSize:11, color:'#9ca3af' }}>{p.req_nome} · {new Date(p.aberto_em).toLocaleDateString('pt-BR')}</div>
                </div>
                <StatusBadge status={p.status} />
                <span style={{ color:'#d1d5db', fontSize:16 }}>›</span>
              </div>
            ))
        }
      </div>
    </Layout>
  )
}
